import { StarBoxIcon } from './StarBoxIcon';

/**
 * author: Austin Andrews
 * id 07CA9ED6-5D94-4145-AB3E-EA9FD7283E0A
 * name star-box
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-box.svg
 * tags
 */
export const FavoriteBoxIcon = StarBoxIcon;
export default FavoriteBoxIcon